import styled from "styled-components";

const CustomerInfo = styled.div`

.kitPopup-content {
    background-color: red;
}

.get-nutritional-code {
    .get-nutritional-code-button {
        color: #0094d5;
                span {
            font-size: 12px;
            line-height: 1.25;
            display: block;
            margin-top: 3px;
        }
    }
}
.text_section {
    .container {
        max-width: 1015px;

        .advanced-privacy-content {
            &>p {
                text-align: center;
                margin-top: 16px;

                @media only screen and (max-width: 767px) {
                    text-align: left;
                }
            }
            p {
                line-height: 1.4;
                margin-bottom: 24px;
                font-size: 27px;

                @media only screen and (max-width: 767px) {
                    font-size: 24px;
                }

                @media only screen and (max-width: 767px) {
                    font-size: 22px;
                    margin-bottom: 16px;
                }
            }
            .d-flex {

                @media only screen and (max-width: 767px) {
                    flex-direction: column-reverse;
                }


                .content-privacy-protection {
                    width: 39%;

                    @media only screen and (max-width: 1199px) {
                        width: 50%;
                    }

                    @media only screen and (max-width: 991px) {
                        width: 60%;
                    }

                    @media only screen and (max-width: 767px) {
                        width: 100%;
                    }
                }
                .text-privacy-protection {
                    width: 60%;
                    margin-left: 1%;

                    @media only screen and (max-width: 1199px) {
                        width: 50%;
                    }

                    @media only screen and (max-width: 991px) {
                        width: 40%;
                    }

                    @media only screen and (max-width: 767px) {
                        width: 100%;
                        margin: 0;
                    }

                    .advanced-privacy {
                        font-family: var(--inte-BD);
                        font-size: 63px;
                        line-height: 1.4;
                        margin: -15px auto 0;
                        max-width: 460px;
                        color: #5fa3ac;

                        @media (max-width: 1280px){
                            font-size: 50px;
                        }
                        @media (max-width: 991px){
                            font-size: 40px;
                        } 
                        @media (max-width: 767px){ 
                            font-size: 30px;
                            max-width: unset;
                            margin: 0 0 16px;
                        }
                    }
                }
            }
        }
    }
}



.container.customerinfo-main-section {
    max-width: 1045px;
    /* padding-top: 160px; */
    padding-top: 200px;
    color: black;
    position:relative;

    @media only screen and (max-width: 1199px) {
        padding-top: 170px;
    }

    @media only screen and (max-width: 767px) {
        padding-top: 112px;
    }
}
.customerinfo-main-section {
    h4 {
        font-size: 26px;
        line-height: 1.2;
        text-align: left;
        font-family: 'SFPro';
        font-weight: 700;
        margin: 0 0 15px;

        @media only screen and (max-width: 1199px) {
            font-size: 24px;
        }

        @media only screen and (max-width: 767px) {
            font-size: 22px;
        }
    }

    a {
        text-decoration: none;
    }
    h2 {
        font-size: 43px;
        line-height: 1.15;
        color: #000000;
        /* font-family: var(--inte-BD); */
        /* font-family: 'Graphik'; */
        /* font-family: var(--common-font); */
        font-family: 'SFPro';
        margin-top: 0;
        text-align: center;
        font-weight: 700;

        @media only screen and (max-width: 1199px) {
            font-size: 36px;
        }

        @media only screen and (max-width: 767px) {
            font-size: 28px;
        }
    }

    h2.now-you-heading, .genertic-potential-heading, .code-complex-heading, .fast-track-to-heading { 
        font-size: 45px;
        line-height: 1.2;
        /* font-family: var(--inte-BD); */
        padding: 0;
        /* max-width: 550px;
        margin: 0 auto 10px; */

        @media only screen and (max-width: 1199px) {
            font-size: 36px;
        }

        @media only screen and (max-width: 767px) {
            font-size: 28px;
        }
    }  

    .fast-track-to-heading {
        padding-top: 40px;
        /* color: #bd1b86 !important; */
        color: #bb145a !important;
        text-transform: uppercase;

        @media only screen and (max-width: 1199px) {
            padding-top: 30px;
        }

        @media only screen and (max-width: 767px) {
            padding-top: 20px;
        }
    }

    h3 {
        font-size: 36px;
        line-height: 1.2;
        color: #000000;
        font-size: 36px;
        line-height: 1.2;
        text-align: center;
        font-family: 'SFPro';
        font-weight: 700;
        margin: 40px 0 15px;

        @media only screen and (max-width: 1199px) {
            font-size: 32px;
        }

        @media only screen and (max-width: 767px) {
            font-size: 25px;
        }
    }
    
    .find-out-button-section {
        padding: 0;
        margin-bottom: 30px;

        .find-out-button {
            display: inline-block;
            /* font-style: italic; */
        }
    }

    .data-required-section {
        h3 {
            font-size: 36px;
            line-height: 1.2;
            text-align: center;
            font-family: 'SFPro';
            font-weight: 700;
            margin: 40px 0 15px;

            @media only screen and (max-width: 1199px) {
                font-size: 32px;
            }

            @media only screen and (max-width: 767px) {
                font-size: 25px;
            }
        }

        h4 {
            font-size: 26px;
            line-height: 1.2;
            text-align: left;
            font-family: 'SFPro';
            font-weight: 700;
            margin: 0 0 15px;

            @media only screen and (max-width: 1199px) {
                font-size: 24px;
            }

            @media only screen and (max-width: 767px) {
                font-size: 22px;
            }
        }


        .cmn-heading-wrap {
            margin-bottom: 30px;
        }
    }

    .info-accordion-section {
        margin-bottom: 40px;

        .MuiAccordion-root {
            background-color: transparent;
            box-shadow: none;
            border-radius: 0;

            &::before {
                display: none;
            }

            &.Mui-expanded {
                margin: 0;
            }

            .MuiButtonBase-root {
                padding: 7px 0;
                min-height: auto;
                border-bottom: 1px solid #000;

                .MuiAccordionSummary-content {
                    margin: 0;

                    .MuiTypography-root {
                        display: flex;
                        /* flex-wrap: wrap; */
                        align-items: start;
                        flex: 1;
                        font-size: 26px;
                        line-height: 1.2;
                        margin: 0;

                        @media only screen and (max-width: 1199px) {
                            font-size: 24px;
                        }

                        @media only screen and (max-width: 767px) {
                            font-size: 20px;
                        }

                        .refunds-provide {
                            margin-right: 10px;
                            font-family: var(--common-fontmd);
                        }

                        p {
                            margin: 0;
                            margin-left: auto;
                            color: #666;
                            white-space: nowrap;
                            line-height: 1.5;
                        }

                        .accordian-icon {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 20px;
                            line-height: 1.5;

                            svg {
                                height: 30px;
                                width: 26px;

                                @media only screen and (max-width: 1199px) {
                                    width: 24px;
                                }

                                @media only screen and (max-width: 767px) {
                                    width: 22px;
                                }
                            }
                        }
                    }
                }
            }
            .MuiCollapse-root {
                .MuiAccordionDetails-root {
                    padding: 5px 20px 20px;
                }
                .MuiTypography-root {
                    margin: 0;
                    p {
                        margin: 0;
                    }
                }
            }
        }
    }
}
h2.now-you-heading {
    padding: 0px 200px 0px 200px;
    font-size: 45px;
    line-height: 52px;
    /* color: #bd1b86 !important; */
    color: #bb145a !important;
    text-transform: uppercase;
}

.customerinfo-main-section p {
    /* font-size: 23px;
    line-height: 30px; */
    font-size: 20px;
    line-height: 1.2;
    color: #000;
    margin-bottom: 25px;
    font-weight: 500;

    a {
        font-family: 'SFPro';
    }

    .txt-undrline {
        text-decoration: underline;
        /* cursor: pointer; */
    }
}
a.only-one-anchor {
    color: #000;
    text-decoration: revert;
}

 a.find-out-button {
    padding: 10px 40px;
    border-radius: 30px;
    background: linear-gradient(90deg,#e40685 0%,#bd1b86 21%,#632e8a 100%);
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    font-family: var(--exo);
    cursor: pointer;
}
.find-out-button-section {
    text-align: center;
    padding: 20px;
}

.data-required-section h3{
    font-size: 24px;
    color: #000;
    font-weight: 800;
    font-style: italic;
}

h2.genertic-potential-heading {
    font-size: 41px;
    line-height: 52px;
    /* color: #bd1b86 !important; */
    color: #bb145a !important;
    text-transform: uppercase;
}

.code-complex-heading {
    text-transform: uppercase;
}

.main-three-container-section {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 24px;
    padding: 10px 0 60px;
}

.box-content-section {
    text-align: center;
    padding: 0px 10px 10px 0px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    p {
        line-height: 30px;
    }
}

.get-nutritional-code {
    margin-top: 30px;
}

.get-nutritional-code-button {
    padding: 10px 20px;
    border-radius: 50px;
    background: white;
    color: var(--green);
    font-weight: 600;
    display: inline-block;
    font-size: 22px;
    line-height: 1.2;
    font-family: var(--exo);

    @media only screen and (max-width:991px) {
        font-size: 20px;
    }
}
a.get-nutritional-code-button {
    cursor: pointer;
}

.box-content-section {
    /* height: 435px; */
    border-radius: 20px;
    padding: 20px 25px 45px;
    position: relative;
    overflow: hidden;
    width: calc(100%/3 - 16px);

    @media only screen and (max-width:991px) {
        width: 100%;
    }

    h2 {
        font-size: 33px;
        line-height: 1;
        margin-bottom: 20px;

        @media only screen and (max-width: 1199px) {
            font-size: 34px;
        }

        @media only screen and (max-width: 767px) {
            font-size: 26px;
        }
    }
}

.box-content-section.disabled {
    background-color: #B3B3B3;
    pointer-events: none;

    .get-nutritional-code-button {
        background-color: #cdcdcd;
        color: #9a9a9a;
    }
    h2, p {
        color: #9a9a9a;
    }

    .coming-soon-text { 
        padding: 10px;
        background-color: #D41C24;
        width: calc(100% + 30px);
        position: absolute;
        top: 37%;
        left: -15px;
        transform: rotate(-11deg);

        @media only screen and (max-width:991px) {
            transform: rotate(-4deg);
        }
        
        h4 {
            color: #fff;
            font-size: 27px;
            line-height: 1.1;
            margin: 0;
            text-align: center;
        }
    }
}

.andme-first-section.box-content-section {
    background: linear-gradient(90deg,#00a0e1 0%,#009db0 24%,#00997c 100%);
}

.andme-first-section.box-content-section h2 {
    color: white;
}
.andme-first-section.box-content-section p {
    color: white;
}
.container.customerinfo-main-section{
    &.supportn-section {
        padding: 30px 15px 60px;

        .code-complex-heading {
            h2 {
                color: #fff;
            }
        }

        .supportn-heading {
            /* margin-bottom: 50px; */
            max-width: 680px;
            margin: 0 auto 50px;
        }
    }
}

.nutrition-support-section {
    background: linear-gradient(90deg,#00a0e1 0%,#009db0 24%,#00997c 100%); 
}

#nutrition-section {
    scroll-margin: 170px;

    @media only screen and (max-width: 1280px) {
        scroll-margin: 150px;
    }

    @media only screen and (max-width: 767px) {
        scroll-margin: 92px;
    }
}

.nutrition-support-section {
    h2 {
        color: white;
        /* font-family: var(--inte-BD); */
        font-family: 'SFPro';
        margin: 0;
        text-align: center;
        text-transform: unset;
    }

    .code-complex-heading {
        text-transform: uppercase;
        font-family: var(--inte-BD);
    }
}

.nutrition-support-section h3 {
    font-size: 27px;
    line-height: 1.2;
    color: white;
    font-weight: 800;
    margin: 0 0 20px;
}

.main-support-section {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .left-product-content, .right-image-section {
        width: calc(100%/2);

        @media only screen and (max-width: 991px) {
            width: 100%;
        }
    }

    .left-product-content {
        h3 {
            text-align: left;
            font-family: var(--common-font);
        }
    }

    .right-image-section {
        position: relative;

        @media only screen and (max-width: 991px) {
            max-width: 500px;
            margin: 30px auto 0;
        }

        figure {
            text-align: center;

            img {
                object-position: center;
                object-fit: contain;
            }
        }

        ul {
            position: absolute;
            top: 0;
            right: 0;

            @media only screen and (max-width: 991px) {
                position: static;
                display: flex;
                justify-content: center;
                margin: 20px 0 0;
            }

            li {
                font-size: 8px;
                line-height: 1.2;
                font-weight: 700;
                color: #000;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 0;               

                @media only screen and (max-width: 991px) {
                    margin: 0 10px;
                }

                &::before {
                    display: none;
                }

                &:not(:last-child) {
                    margin-bottom: 10px;

                    @media only screen and (max-width: 991px) {
                        margin-bottom: 0px;
                    }
                }

                span {
                    background-color: #5FB0B9;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 50px;
                    width: 50px;
                    margin-bottom: 10px;

                    img {
                        height: 30px;
                        width: 26px;
                        object-fit: contain;
                        display: block;
                    }
                }
            }
        }
    }
}

.main-support-section {
    ul {
        list-style: none;

        li {
            color: white;
            font-size: 20px;
            line-height: 1.2;
            padding-left: 25px;
            position: relative;

            &:not(:last-child) {
                margin-bottom: 12px;
            }

            &::before {
                content: "";
                height: 7px;
                width: 15px;
                border-bottom: 2px solid #fff;
                border-left: 2px solid #fff;
                transform: rotate(-45deg);
                display: block;
                position: absolute;
                left: 0;
                top: 6px;
            }

            small {
                font-size: 13px;
                line-height: 1.1;
                display: block;
                margin-top: 12px;
            }
        }
    }
}


.first-section-right-image img {
    width: 100%;
    height: 80%;
    object-fit: cover;
}
.container.customerinfo-main-section.accordian-section-main {
    padding-top: 30px;
}
.first-section-main {
    margin: 50px 0;
    display: flex;
    @media(max-width:991px){
        flex-wrap:wrap;
    }
    .first-section-left-content {
    padding-right: 36px;
    @media(max-width:991px){
        padding-right:0;
    }
}
}
.second-section-main {
    display: flex;
    margin:50px 0 20px;
    @media(max-width:991px){
        flex-wrap:wrap;
    }
}

.second-section-left-image img {
    width: 100%;
    height: 100%;
}
.third-section-right-image img {
    width: 100%;
    height: 100%;
}
.third-section-main {
    display: flex;
    margin:50px 0 20px;
    @media(max-width:991px){
        flex-wrap:wrap;
    }
}
.third-left-section {
    width:100%;
    flex: unset;
    padding-right: 0;
}
.second-section-right-content {
    padding-left: 20px;
    @media(max-width:991px){
        padding-left: 0;
        padding-top:20px;
    }

}
.third-section-right-image {
    float: right;
    width: 50%;
    margin-left: 15px;
    margin-bottom: 20px;
    @media(max-width:991px){
        width: 100%;
    margin-left: 0;
    }
}
.third-left-section p {
    padding-bottom: 37px;
}
h2.fast-track-to-heading {
    font-size: 41px;
    line-height: 52px;
    /* color: #bd1b86 !important; */
    color: #bb145a !important;
    padding-top: 50px;
}
.third-left-section p:last-child {
    padding-bottom: 0;
    margin-bottom: 0;
}
.second-section-left-image img {
        max-height: 405px;
    width: 290px;
@media(max-width:991px){
    max-height: unset;
    width: 100%;
}
}
.andme-second-section.box-content-section {
    background: linear-gradient(90deg,#00a0e1 0%,#009db0 24%,#00997c 100%);
}
.andme-second-section.box-content-section p {
    color: #fff;
}
span.other-resources{
    color: #fff;
    position: relative;
    bottom: 11px;
    /* font-family: 'SFPro-Regular'; */
    /* font-size: 14px; */
}
`;

export default CustomerInfo;